/*
 * @Author: WYX
 * @Date: 2020-01-09 13:17:09
 * @LastEditTime : 2020-01-09 21:56:09
 * @LastEditors  : WYX
 * @FilePath:
 * @Description: 资源中心列表指令
 */
angular
    .module('resourceListModule', [
        'resourceListCardModule',
        'messageChangeModule',
        'resourceVideoUploadModule',
    ])
    .controller('resourceListCtrl', ['$scope', function($scope) {}, ]);
